export const guard_mixin = {
    data() {
        return {}
    },

    methods: {},

    computed: {
        hasCommitPermission() {
            switch (this.$store.state.roleType) {
                case "ADMIN":
                case "MANAGE":
                case "GUARD":
                    return true
                case "VIEW":
                case "STAFF":
                    return false
                case "COMMON":
                    return this.$store.state.myPermissions.includes("GUARD_HELPER_MODIFY")
                default:
                    return false
            }
        }
    },

}
